import React from "react";
import "./SearchAccountItem.css";
import { Avatar, Row, Tooltip } from "antd";
import FollowButton from "../../../Components/FollowButton/FollowButton";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WatchMoreText from "../../../Components/WatchMoreText/WatchMoreText";
import { useNavigate } from "react-router-dom";

function SearchAccountItem({ userInfo }) {
  const navigate = useNavigate();
  const testBio =
    "Một chút thông tin về tiểu sử của anh/cô ấy có thể sẽ hiện ra ở đây nhưng đây là tài khoản thử nghiệm nên đây chỉ là một thông báo dài dòng mà thôi! Đây là dòng xuất hiện chỉ với mục đích tăng thêm độ dài nên sẽ lặp lại dòng trước và đây là một chút thông tin về tiểu sử của anh/cô ấy có thể sẽ hiện ra ở đây nhưng đây là tài khoản thử nghiệm nên đây chỉ là một thông báo dài dòng mà thôi. Như 2 dòng trên, một chút thông tin về tiểu sử của anh/cô ấy có thể sẽ hiện ra ở đây nhưng đây là tài khoản thử nghiệm nên đây chỉ là một thông báo dài dòng mà thôi";

  const handleNavigateProfile = () => {
    if (userInfo) {
      navigate(`/profile/${userInfo?._id}`);
    }
  };

  return (
    <>
      <div className="searchAccItemWrapper">
        <Avatar
          className="searchAccItemAvt"
          size={135}
          src={userInfo?.avatar || "/blankAvatarImg.jpg"}
          onClick={handleNavigateProfile}
        />
        <div className="searchAccInfoWrapper">
          <span className="searchAccName" onClick={handleNavigateProfile}>
            {userInfo?.username}
          </span>
          <WatchMoreText textInput={testBio} />
          <div className="searchAccFollowArea">
            <span className="searchAccFollowInfo">
              <FontAwesomeIcon icon={faUserGroup} />{" "}
              {userInfo?.followers?.length}
            </span>
            <FollowButton />
          </div>
        </div>
      </div>
    </>
  );
}

export default SearchAccountItem;
